import { TRESPONSE_GET_ORDER_TIMELINE_VIEW } from '@monorepo/types';
import { TIMELINE_MODEL } from '../timeline.model';
import { TRange, TTimelineModel } from '../timeline.types';
import { getLeftNavBackgroundColour } from '../timeline.utils';

const STRIP_START_TIME = '00:30:00';
const STRIP_END_TIME = '23:30:00';

export const ORDER_TIMELINE_VIEW_BOARD_TIMELINE_MODEL = {
  createModel: (res: TRESPONSE_GET_ORDER_TIMELINE_VIEW): TOrderTimelineViewTimelineModel => {
    return TIMELINE_MODEL.createTimelineModel(res.dateViewResponse, res.orderViewInfo, (orderDto, orderIdx) => {
      const groupId = `order_timeline_view_board_${orderDto.userOtlId}`;
      return {
        id: groupId,
        data: orderDto,
        entities: orderDto.factoryProcessBreakdowns.map((lineData, lineIdx) => {
          const lineId = `${groupId}_${lineIdx}`;
          return {
            id: lineId,
            name: { displayTxt: orderDto.userOtlId, isClickable: false },
            metadata: {
              subTitle: lineData.factoryName,
              leftCount: 0,
              rightCount: 0,
              title: lineData.processName,
            },
            data: lineData,
            elements: lineData.dayWiseQty.map((stripData, stripIdx): TOrderTimelineViewStripElement => {
              // [NOTE]: Timestamps to add some padding between strips
              const startDate = `${stripData.date} ${STRIP_START_TIME}`;
              const endDate = `${stripData.date} ${STRIP_END_TIME}`;

              return {
                id: `${lineId}_${stripIdx}`,
                data: stripData,
                color: '#EAEEF0',
                iconList: [],
                mask: false,
                name: `${stripData.qty}`,
                range: { startDate, endDate } as TRange,
                stackCount: 0,
                type: 'STRIP' as const,
                textList: [
                  {
                    value: `${stripData.qty}`,
                    color: '#000',
                    align: 'center',
                    justify: 'center',
                    fontSizeInPx: 14,
                  },
                ],
              };
            }),
          };
        }),
        holidays: [],
        name: 'Order Timeline Board',
        backgroundColor: getLeftNavBackgroundColour(orderIdx, '#cfd0d4', '#f8f9f9'),
      };
    });
  },
};

type TOrderTimelineViewTimelineModel = TTimelineModel<
  TRESPONSE_GET_ORDER_TIMELINE_VIEW['orderViewInfo'][number],
  TRESPONSE_GET_ORDER_TIMELINE_VIEW['orderViewInfo'][number]['factoryProcessBreakdowns'][number],
  TRESPONSE_GET_ORDER_TIMELINE_VIEW['orderViewInfo'][number]['factoryProcessBreakdowns'][number]['dayWiseQty'][number]
>;

type TOrderTimelineViewStripElement =
  TOrderTimelineViewTimelineModel['entities'][number]['entities'][number]['elements'][number];
